const CRISP_SCRIPT_ID = "crisp-chat-sdk";

let crispInitialized = false;

const isBrowser = () =>
  typeof window !== "undefined" && typeof document !== "undefined";

const getCrispQueue = () => {
  if (!isBrowser()) {
    return null;
  }

  window.$crisp = window.$crisp || [];
  return window.$crisp;
};

export const initCrisp = (websiteId) => {
  if (!isBrowser() || !websiteId) {
    return false;
  }

  if (crispInitialized) {
    return true;
  }

  const crispQueue = getCrispQueue();
  if (!crispQueue) {
    return false;
  }

  crispQueue.push(["safe", true]);
  window.CRISP_WEBSITE_ID = websiteId;

  if (!document.getElementById(CRISP_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = CRISP_SCRIPT_ID;
    script.src = "https://client.crisp.chat/l.js";
    script.async = true;
    document.head.appendChild(script);
  }

  crispInitialized = true;
  return true;
};

export const setCrispUserContext = ({ userId, email, nickname, accountType }) => {
  const crispQueue = getCrispQueue();
  if (!crispQueue) {
    return;
  }

  if (email) {
    crispQueue.push(["set", "user:email", [String(email)]]);
  }

  if (nickname) {
    crispQueue.push(["set", "user:nickname", [String(nickname)]]);
  }

  const sessionData = [];
  if (userId !== undefined && userId !== null) {
    sessionData.push(["applypa_user_id", String(userId)]);
  }
  if (accountType) {
    sessionData.push(["applypa_account_type", String(accountType)]);
  }

  if (sessionData.length > 0) {
    crispQueue.push(["set", "session:data", [sessionData]]);
  }

  const segments = ["applypa"];
  if (accountType) {
    segments.push(`account_${String(accountType)}`);
  }
  crispQueue.push(["set", "session:segments", [segments, true]]);
};

export const setCrispVisibility = (isVisible) => {
  const crispQueue = getCrispQueue();
  if (!crispQueue) {
    return;
  }

  crispQueue.push(["do", isVisible ? "chat:show" : "chat:hide"]);
};

export const resetCrispSession = () => {
  const crispQueue = getCrispQueue();
  if (!crispQueue) {
    return;
  }

  crispQueue.push(["do", "session:reset"]);
};
